import { jsx as t } from "../../../external/preact/jsx-runtime/dist/jsxRuntime.module.js";
import i from "classnames";
import { useImageUrl as p } from "../../../hooks/useImageUrl.js";
import { useMemo as c } from "../../../external/preact/hooks/dist/hooks.module.js";
const l = ({ folder: m = "components/", className: r, alt: e, name: s, extension: o }) => {
  const a = p({
    options: c(() => ({ imageFolder: m, extension: o }), [o, m]),
    name: s
  });
  return /* @__PURE__ */ t("img", { className: i("adyen-pe__image", r), alt: e, src: a });
};
export {
  l as Image
};
